import { render, staticRenderFns } from "./GroupCensusList.vue?vue&type=template&id=70d7455d&scoped=true&"
import script from "./GroupCensusList.vue?vue&type=script&lang=js&"
export * from "./GroupCensusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d7455d",
  null
  
)

export default component.exports